import { Route } from "react-router-dom";
import styled from "styled-components";
import { ClientSidebar } from "../../components/ClientSidebar";
import { observer } from "mobx-react";
import {
  Box,
  Avatar,
  useToast,
  useDisclosure,
  Stack,
  HStack,
} from "@chakra-ui/react";
import Board from "../Board";
import Results from "../Results";
import { Profile } from "../Profile";
import LogoImg from "../../assets/logo/logo.png";
import { ClientVideoCategories } from "../ClientVideoCategories";
import { ClientVideo } from "../ClientVideo";
import { ClientVideoPlayer } from "../ClientVideoPlayer";
import { ClientEvaluations } from "../ClientEvaluations";
import { useStores } from "../../hooks/useStores";
import { UserCompleSignupModal } from "../../components/UserCompleSignupModal";
import { useCallback, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { CustomerLongLiveTraining } from "../CustomerLongLiveTraining";
import { ClientObjectives } from "../ClientObjectives";
import { isMobile } from "react-device-detect";
import { useState } from "react";
import { useHistory } from "react-router";
import { ClientMobileHeader } from "../../components/ClientMobileHeader";
import { ClientMobileSidebar } from "../../components/ClientMobileSidebar";
import { MobileBookCoachingSession } from "../MobileBookCoachingSession";
import { MobileBookLiveWorkout } from "../MobileBookLiveWorkout";
import { AddToHomeScreen } from "react-pwa-add-to-homescreen";
import { MobileBookPersonaTrainerActiveSubscription } from "../MobileBookPersonaTrainerActiveSubscription";
import { MobileBookPersonaTrainerInactiveSubscription } from "../MobileBookPersonaTrainerInactiveSubscription";

const ClientRoutes: React.FC = () => {
  return (
    <>
      <Route path={"/client/board"} component={Board} />
      <Route
        path={"/client/book-coaching-session"}
        component={MobileBookCoachingSession}
      />
      <Route
        path={"/client/book-live-workout"}
        component={MobileBookLiveWorkout}
      />
      <Route
        path={"/client/book-personal-trainer"}
        component={MobileBookPersonaTrainerActiveSubscription}
      />
      <Route
        path={"/client/book-personal-trainer-trial"}
        component={MobileBookPersonaTrainerInactiveSubscription}
      />
      <Route path={"/client/results"} component={Results} />
      <Route path={"/client/profile"} component={Profile} />
      <Route path={"/client/evaluations"} component={ClientEvaluations} />
      <Route
        exact
        path={"/client/video-categories"}
        component={ClientVideoCategories}
      />
      <Route
        exact
        path={"/client/video-categories/:categoryExternalId"}
        component={ClientVideo}
      />
      <Route
        path={"/client/video-categories/:categoryExternalId/video/:videoId"}
        component={ClientVideoPlayer}
      />
      <Route
        path="/client/long-live-training"
        component={CustomerLongLiveTraining}
      />
      <Route path="/client/objectives" component={ClientObjectives} />
    </>
  );
};

export const ClientLayout: React.FC = observer(() => {
  const { session } = useStores();
  const toast = useToast();
  const { t } = useTranslation();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = useRef();
  const [isOpenDrawer, setIsOpenDrawer] = useState(false);
  const history = useHistory();

  useEffect(() => {
    session.getSettings();
  }, []);

  const handleChangePassword = useCallback(
    async (data: any) => {
      try {
        await session.changeSessionUserPassword(data.newPassword);
        toast({
          status: "success",
          title: t("common.actionExecutedSuccessfully"),
        });
      } catch (err) {
        console.log(err);
        toast({
          status: "error",
          title: t("common.error"),
        });
      }
    },
    [session, t, toast]
  );

  return (
    <>
      {isMobile ? (
        <Stack>
          <ClientMobileHeader onOpenMenu={onOpen} />
          <Box flex={1}>
            <ClientRoutes />
          </Box>
        </Stack>
      ) : (
        <HStack alignItems="stretch">
          <Box p="30">
            <Avatar size="lg" src={LogoImg} alt={"Sabeda"} />
          </Box>
          <Box flex={1}>
            <ClientRoutes />
          </Box>
          <Stack>
            <ClientSidebar
              isTrialExpired={session.isTrialExpired}
              isSubscriptionDeactivated={session.isSubscriptionDeactivated}
              handleDrawer={() => setIsOpenDrawer(!isOpenDrawer)}
              subscriptionType={session.user?.subscription_type || ""}
            />
          </Stack>
        </HStack>
      )}
      <Box>
        {isMobile && (
          <ClientMobileSidebar
            isOpen={isOpen}
            onClose={onClose}
            isTrialExpired={session.isTrialExpired}
            isSubscriptionDeactivated={session.isSubscriptionDeactivated}
            subscriptionType={session.user?.subscription_type || ""}
          />
        )}
      </Box>
      {session.user && (
        <UserCompleSignupModal
          isOpen={!Boolean(session.user?.signupCompleted)}
          isSubmitting={session.isSubmitting}
          user={session.user}
          onSubmit={handleChangePassword}
        />
      )}
      <AddToHomeScreen
        cookie={{ name: "sabeda-add-to-home-pwa" }}
        translate={{
          headline: "Accedi più velocemente a Sabeda!",
          safariTapShare: 'Clicca "Condividi"',
          safariAddHomeScreen: 'e seleziona "Aggiungi alla schermata Home"',
          chromiumAddHomeScreen:
            'Clicca "Aggiungi alla schermata Home" nel menu del browser',
          chromiumInstall: "L'icona apparirà nella tua schermata principale",
          buttonInstall: "Installa",
        }}
      />
    </>
  );
});

export default styled(ClientLayout)`
  & {
    min-height: 100vh;
  }
`;
